import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "./matter";
import type { APIResponse, ClaimType } from "@/lib/types";

export const retrieveClaimTypes = () =>
  authenticatedFastApiAxiosInstance
    .get<APIResponse<ClaimType[]>>(`${baseFastApiMatterRoute}/claim-types`)
    .then((response) => response.data);
